<zah-diensten-navigation [user]="user"
  [client]="client"
  [diensten]="diensten"
  [zones]="zones"
  [isPrestatiePage]="!!prestatie"
  (meldingenClicked)="onMeldingenClicked()"
  (prestatieClicked)="onPrestatieClicked()"
  (signaalkaartClicked)="onSignaalkaartClicked()"
  (wijzigClientClicked)="onWijzigClientClicked()"
  (clientFicheClicked)="onClientFicheClicked()"
  (categorieSelected)="openCategory($event)">
  <div class="content">
    @if (diensten.isEmpty()) {
      <div
        class="no-taken">
        {{emptyLabel}}
      </div>
    }
    @if (dienst) {
      <zah-taken-list
        [prestatie]="prestatie"
        [dienst]="dienst"
        [category]="categorie"
        [taken]="taken"
        [taakTipAantallen]="taakTipAantallen"
        (tipsOpened)="onTipsOpened($event)">
      </zah-taken-list>
    }
    <div class="fade-in"></div>
    <div class="footer">
      <ng-content></ng-content>
    </div>
  </div>
</zah-diensten-navigation>
